import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateMarketingCampaignsState } from "./types";
import { IMarketingCampaing } from "@/shared/api/marketing-campaigns";

const initialState: UpdateMarketingCampaignsState = {
    isToggleCampaignModalOpen: false,
    isPostResultsModalOpen: false,
    campaign: {
        id: "",
        name: "",
        bot_id: "",
        invitation_id: "",
        start_date: "",
        end_date: "",
        prizes: [],
        limit: 0,
        events: [],
        total_activated: 0,
        is_finished: false,
        is_active: false,
        is_draw: false,
        auto_post_results: false,
        auto_post_channel: null
    },
    onToggle: null
}

interface OpenPostResultsModalPayload {
    data: IMarketingCampaing,
}

interface OpenToggleCampaignModalPayload {
    data: IMarketingCampaing,
    onToggle?: () => void
}

const updateMarketingCampaignsSlice = createSlice({
    name: 'updateMarketingCampaigns',
    initialState,
    reducers: {
        openToggleCampaignModal: (state, action: PayloadAction<OpenToggleCampaignModalPayload>) => {
            state.campaign = action.payload.data
            state.isToggleCampaignModalOpen = true
            state.onToggle = action.payload.onToggle
        },
        closeToggleCampaignModal: (state) => {
            state.isToggleCampaignModalOpen = false
        },
        openPostResultsModal: (state, action: PayloadAction<OpenPostResultsModalPayload>) => {
            state.campaign = action.payload.data
            state.isPostResultsModalOpen = true
        },
        closePostResultsModal: (state) => {
            state.isPostResultsModalOpen = false
        },
    }
})

export default updateMarketingCampaignsSlice.reducer
export const { 
    closeToggleCampaignModal,
    openToggleCampaignModal,
    openPostResultsModal,
    closePostResultsModal
} = updateMarketingCampaignsSlice.actions